import { useContext } from 'react';
import { type Dictionary } from './dictionary.js';
import { LanguageContext, type LanguageContextValue } from './LanguageProvider.js';

export function useLanguage(): LanguageContextValue {
  const value = useContext(LanguageContext);
  if (value === null) {
    throw new Error('useLanguage must be used inside <LanguageProvider>');
  }
  return value;
}

/** Shorthand for the many components that only need the dictionary. */
export function useTranslation(): Dictionary {
  return useLanguage().t;
}
